// routes/_embedded.embedded.news.$id.tsx
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_embedded.embedded.news.$id')

export const handle = { name: 'embedded-news' }

export default dynamic(getClientModule, { ssr: false })
